import { Component, OnInit } from '@angular/core';
import { Subject, fromEvent, takeUntil } from 'rxjs';
import { MatDialog } from '@angular/material/dialog';
import { ToastrService } from 'ngx-toastr';
import { CommonService } from 'src/app/shared/services/common.service';
import { Router } from '@angular/router';
import { PlayerServicesService } from 'src/app/shared/services/players-services.service';
import { SpinnerVisibilityService } from "ng-http-loader";
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material/core';
import { MAT_MOMENT_DATE_ADAPTER_OPTIONS, MomentDateAdapter } from '@angular/material-moment-adapter';
import { DatePipe } from '@angular/common';
// import { DatePipe } from '@angular/common';

import { MY_FORMATS } from '../organization-dash/organization-dash.component';

// export const MY_FORMATS = {
//   parse: {
//     dateInput: 'LL',
//   },
//   display: {
//     dateInput: 'LL',
//     monthYearLabel: 'MMM YYYY',
//     dateA11yLabel: 'LL',
//     monthYearA11yLabel: 'MMMM YYYY',
//   },
// };

@Component({
  selector: 'app-team-dash',
  templateUrl: './team-dash.component.html',
  styleUrls: ['./team-dash.component.scss'],
  providers: [
    {
      provide: DateAdapter,
      useClass: MomentDateAdapter,
      deps: [MAT_DATE_LOCALE, MAT_MOMENT_DATE_ADAPTER_OPTIONS],
    },

    { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS },
  ],
})
export class TeamDashComponent implements OnInit {

  selected: any;
  ProfileDetails: any;
  userType: any = false;
  EventList: any = [];
  restaurantList: any;
  date = new Date();
  todayDate: Date = new Date();
  ShowEvents: true
  SelectedEvents: false;
  searchData:any;
  datepipe: DatePipe = new DatePipe('en-US')

  // formattedEventDate: string;
  // i: any;

  private unsubscriber: Subject<void> = new Subject<void>();
  currentUser: any = localStorage.getItem("currentUser")

  playersDataList = [
    { name: "US Game" },
    { name: "US Game" }
  ];

  constructor(
    private router: Router,
    private playserv: PlayerServicesService,
    private spinner: SpinnerVisibilityService,
    // private datePipe: DatePipe
  ) {
    // this.formattedEventDate = this.datePipe.transform(this.i.eventDate, 'yyyy-MM-ddTHH:mm:ss.SSSZ', 'UTC');

    history.pushState(null, '');

    fromEvent(window, 'popstate').pipe(
      takeUntil(this.unsubscriber)
    ).subscribe((_) => {
      history.pushState(null, '');
      // this.toast.error(`Pleas.`);
    });
  }

  ngOnInit(): void {
    this.getRestaurantAPICall();
    this.getUpcomingOrders();
    // this.playerGetEvents();
  }
  ViewMenu(id) {
    // this.router.navigate(['/products/']) 
    this.router.navigate(['/products', id?.restaurantData?._id], { queryParams: { eventId: id?._id } });
  }



  onClickChangeDate(e: any) {
    console.log(e)
    this.spinner.show();
    // let month = e.getMonth();
    let month = e._i.month;
    let months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
    // let req = `${months[month]} ${e.getDate()}, ${e.getFullYear()}`;
    let req = `${months[month]} ${e._i.date}, ${e._i.year}`;
    let selectedDate = new Date(req);

    // Convert selectedDate to UTC format
    let selectedDateUTC = new Date(selectedDate.getTime() - selectedDate.getTimezoneOffset() * 60000).toISOString();
    console.log(selectedDateUTC,"====================================");
    let data = { "page":1,"pageLimit":1000, "selectedDate": selectedDateUTC };
    // this.playserv.getEventByDate(data).subscribe((res: any) => {
    //   if (res.status == 200) {
    //     console.log(res?.output?.length);
    //     this.EventList = res.output;
    //     if (res.output?.length == 0 || res.output?.length==undefined) {
    //       this.EventList = [];
    //     }
    //   }
    // })
    this.getRestaurantAPICall();
    this.getUpcomingOrders();
    this.spinner.hide();
  }

  getUpcomingOrders(){
    let data = {// "date":"2023-11-21"
    }
    // if(this.selected){
    //   let fullDate = new Date(this.selected);
    //   let date:any =  fullDate.getDate();
    //   if(date<10){
    //     date = `0${date}`
    //   }

    //   let month:any =  fullDate.getMonth()+1;
    //   if(month<10){
    //     month = `0${month}`
    //   }
    //   let year = fullDate.getFullYear();
    //   data['date']= `${year}-${month}-${date}`
    // }

    let hours:any = new Date().getHours();
    if(hours<10){
      hours = `0${hours}`
    }
    let min:any = new Date().getMinutes();
    if(min<10){
      min = `0${min}`
    }

    if(this.selected){
      let fullDate = new Date(this.selected);
      let date:any =  fullDate.getDate();
      if(date<10){
        date = `0${date}`
      }

      let month:any =  fullDate.getMonth()+1;
      if(month<10){
        month = `0${month}`
      }
      let year = fullDate.getFullYear();
      


      let currentDate = new Date();
      let date1:any = currentDate.getDate();
      let month1:any = currentDate.getMonth()+1;
      let year1 = currentDate.getFullYear();
      if(date1<10){
        date1 = `0${date1}`
      }
      if(month1<10){
        month1 = `0${month1}`
      }

      if(`${year1}-${month1}-${date1}`==`${year}-${month}-${date}`){
        let dates = new Date(`${year}-${month}-${date} ${currentDate.getHours()}: ${currentDate.getMinutes()}`);
        let utcDateTime = this.datepipe.transform(dates, 'YYYY-MM-dd HH:mm:ss', 'UTC')
        data['date']= 'today';
        data['currentDate'] = `${this.datepipe.transform(new Date(), 'YYYY-MM-dd')}T${hours}:${min}:00.000Z`;
        // data['date']= utcDateTime
      }else{
        data['date']= `${year}-${month}-${date}`;
        data['currentDate'] = `${year}-${month}-${date}T${hours}:${min}:00.000Z`;
      }

    }else{

      let dateToday = new Date();
      let yearNow = dateToday.getFullYear();
      let dateNow:any = dateToday.getDate();
      let monthNow:any = dateToday.getMonth() + 1;
      if(dateNow<10){
        dateNow = `0${dateNow}`
      }
      if(monthNow<10){
        monthNow = `0${monthNow}`
      }
      data['currentDate'] = `${yearNow}-${monthNow}-${dateNow}T${hours}:${min}:00.000Z`;

      // data['currentDate'] = `${this.datepipe.transform(new Date(), 'YYYY-MM-dd')}T${hours}:${min}:00.000Z`;
    }
    this.playserv.getUpcomingOrders(data).subscribe((res:any)=>{
      if (res.status == 200) {
        this.EventList = res.output
        if (res.output?.length == 0 || res.output?.length==undefined) {
          this.EventList = []
        }
      }
    })
  }

  playerGetEvents(){
    // this.playserv.playerUpcoingOrders().subscribe((res: any) => {
    //   if (res.status == 200) {
    //     this.EventList = res.output
    //     if (res.output.length == 0) {
    //       this.EventList = []
    //     }
    //   }
    // })
    let e = new Date();
    let month = e.getMonth();
    let months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
    let req = `${months[month]} ${e.getDate()}, ${e.getFullYear()}`;
    let selectedDate = new Date(req);

    // Convert selectedDate to UTC format
    let selectedDateUTC = new Date(selectedDate.getTime() - selectedDate.getTimezoneOffset() * 60000).toISOString();
    // , "selectedDate": selectedDateUTC
    this.playserv.getEventByDate({ "page":1,"pageLimit":1000 }).subscribe((res: any) => {
      if (res.status == 200) {
        this.EventList = res.output
        if (res.output?.length == 0 || res.output?.length==undefined) {
          this.EventList = []
        }
      }
    })
  }

  getRestaurantAPICall() {
    try {
      let req_body = {
        "page": 1,
        "pageLimit": 100,
        "search": this.searchData
      }
      if(!this.searchData){
        delete req_body.search
      }

      // if(this.selected){
      //   let month = this.selected._i.month;
      //   let months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
      //   let req = `${months[month]} ${this.selected._i.date}, ${this.selected._i.year}`;
      //   let selectedDate = new Date(req);
      //   let selectedDateUTC = new Date(selectedDate.getTime() - selectedDate.getTimezoneOffset() * 60000).toISOString();

      //   req_body['selectedDate'] = selectedDateUTC
      // }

      let hours:any = new Date().getHours();
      if(hours<10){
        hours = `0${hours}`
      }
      let min:any = new Date().getMinutes();
      if(min<10){
        min = `0${min}`
      }

      if(this.selected){
        let month = this.selected._i.month;
        let months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
        let req = `${months[month]} ${this.selected._i.date}, ${this.selected._i.year}`;
        let selectedDate = new Date(req);
        let selectedDateUTC = new Date(selectedDate.getTime() - selectedDate.getTimezoneOffset() * 60000).toISOString();
        // req_body['selectedDate'] = selectedDateUTC


        let fullDate = new Date(this.selected);
        let date:any =  fullDate.getDate();
        if(date<10){
          date = `0${date}`
        }

        let monthNew:any =  fullDate.getMonth()+1;
        if(monthNew<10){
          monthNew = `0${monthNew}`
        }
        let year = fullDate.getFullYear();


        let currentDate = new Date();
        let date1:any = currentDate.getDate();
        let month1:any = currentDate.getMonth()+1;
        let year1 = currentDate.getFullYear();
        if(date1<10){
          date1 = `0${date1}`
        }
        if(month1<10){
          month1 = `0${month1}`
        }

        console.log(`${year1}-${month1}-${date1}`,`${year}-${monthNew}-${date}`)
        if(`${year1}-${month1}-${date1}`==`${year}-${monthNew}-${date}`){
          let dates = new Date(`${year}-${month}-${date} ${currentDate.getHours()}: ${currentDate.getMinutes()}`);
          let utcDateTime = this.datepipe.transform(dates, 'YYYY-MM-dd HH:mm:ss', 'UTC')
          // data['date']= utcDateTime
          req_body['selectedDate']= 'today';
          req_body['currentDate'] = `${this.datepipe.transform(new Date(), 'YYYY-MM-dd')}T${hours}:${min}:00.000Z`;
        }else{

          req_body['selectedDate'] = selectedDateUTC;
          req_body['currentDate'] = `${selectedDateUTC.split("T")[0]}T${hours}:${min}:00.000Z`;
        }
      }else{

        let dateToday = new Date();
        let yearNow = dateToday.getFullYear();
        let dateNow:any = dateToday.getDate();
        let monthNow:any = dateToday.getMonth() + 1;
        if(dateNow<10){
          dateNow = `0${dateNow}`
        }
        if(monthNow<10){
          monthNow = `0${monthNow}`
        }
        req_body['currentDate'] = `${yearNow}-${monthNow}-${dateNow}T${hours}:${min}:00.000Z`;
        // req_body['currentDate'] = `${this.datepipe.transform(new Date(), 'YYYY-MM-dd')}T${hours}:${min}:00.000Z`;
      }

      this.playserv.getRestaurant(req_body).subscribe(
        (res: any) => {
          this.restaurantList = res.output.list
        },
        (err: any) => {
          this.spinner.hide();
        }
      )
    }
    catch (e) { }
  }

  search(){
    this.getRestaurantAPICall()
  }

  clearFilter(){
    this.searchData = undefined;
    this.getRestaurantAPICall();
  }

  restbtn() {
    (<HTMLInputElement>document.querySelector('.upcoming-order-btn')).classList.add('active-nav-dash');
    (<HTMLInputElement>document.getElementById('upcoming-order-sect')).style.display = 'block';
    this.anotherMethod();
    

  }

  anotherMethod(){
    (<HTMLInputElement>document.getElementById('event-sect')).style.display = 'none';
    (<HTMLInputElement>document.querySelector('.events-btn')).classList.remove('active-nav-dash');
  }

  eventbtn() {
    (<HTMLInputElement>document.querySelector('.events-btn')).classList.add('active-nav-dash');
    this.setValuee();
  }

  setValuee(){
    (<HTMLInputElement>document.getElementById('upcoming-order-sect')).style.display = 'none';
    (<HTMLInputElement>document.getElementById('event-sect')).style.display = 'block';
    (<HTMLInputElement>document.querySelector('.upcoming-order-btn')).classList.remove('active-nav-dash');
  }

  getWidth(){
    return window.innerWidth;
  }

  checkResolution(data: any) {
    let width = this.getWidth();
    if(width<=999){
      if(data.length>25){
        return data.slice(0,25)+'...' 
      }else{
        return data 
      }
    }else if(width>999){
      if(data.length>35){
        return data.slice(0,35)+'...' 
      }else{
        return data 
      }
    }
  }

  checkResolutionRestaurantName(data: any) {
    let width = window.innerWidth;
    if(width<=600){
      if(data.length>16){
        return data.slice(0,16)+'...' 
      }else{
        return data 
      }
      
    }else{
      if(data.length>35){
        return data.slice(0,35)+'...' 
      }else{
        return data 
      }
    }
  }
}
